module.exports = __webpack_public_path__ + "img/thought.ffb4d09.jpg";